<template>
  <div class="page-wrapper">
    <TVStreaming @tab="switchTab" v-if="tab_switch == 'tv_streaming'"></TVStreaming>
  </div>
</template>
<script>
import TVStreaming from "./TVStreaming.vue";
export default {
  components: {
    TVStreaming,
  },
  data: () => ({
    tab_switch: "tv_streaming",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "tv_streaming";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "streaming", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

